import { Icon } from '@design-system/index'
import { colors, typo } from '@design-system/styles'
import type { DefaultProps } from '@design-system/types/props'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

import type {
  BadgeColorType,
  BadgeFormationType,
  BadgeIconNameType,
  BadgeSizeType,
  BadgeThemeType,
} from './_Badge.type'

interface BadgeProps extends DefaultProps {
  theme?: BadgeThemeType // type과 color를 간편히 세팅할 수 있는 옵션
  size?: BadgeSizeType
  color?: BadgeColorType

  type?: BadgeFormationType
  iconName?: BadgeIconNameType
}

/**
 * @deprecated
 */
export const _NewBadge = ({
  children,
  theme,
  type,
  size,
  color,
  iconName,
  className,
  style,
}: BadgeProps) => {
  const themed:
    | {
        color: BadgeColorType
        type: BadgeFormationType
        iconName?: BadgeIconNameType
      }
    | undefined = (() => {
    switch (theme) {
      case 'autoScoring':
        return { type: 'Solid', color: 'gray' }
      case 'twinApply':
        return { type: 'Solid', color: 'blue' }
      case 'studentAppPrivate':
        return { type: 'Solid', color: 'green100' }
      case 'unlockIcon':
        return { type: 'Icon', color: 'gray', iconName: 'unlock_line' }
      default:
        undefined
    }
  })()

  const colored = themed ? color || themed.color : color || 'gray'
  const sized = themed ? size || 'S' : size || 'S'
  const sizeToPxForIcon = sized === 'S' ? 16 : 24
  const iconNamed = themed
    ? iconName || themed.iconName || 'unlock_line'
    : iconName || 'unlock_line'

  switch (themed ? type || themed.type : type) {
    case 'Text':
      return (
        <TextTypeBadge size={sized} color={colored} className={className} style={style}>
          {children}
        </TextTypeBadge>
      )
    case 'Icon':
      return <Icon name={iconNamed} size={sizeToPxForIcon} className={className} style={style} />
    case 'Solid':
    default:
  }

  return (
    <SolidTypeBadge size={sized} color={colored} className={className} style={style}>
      {children}
    </SolidTypeBadge>
  )
}

export const badgeCommonStyles = css`
  font-weight: 700;
  border-radius: var(--Radius-100);
  color: white;
  white-space: pre;
`

export const smallSizeBadgeStyles = css`
  padding: 2px 4px;
  ${typo.caption02};
  height: 16px;
`
const largeSizeBadgeStyles = css`
  padding: 2px 6px;
  ${typo.body02};
  height: 28px;
`

export const newBadgeStyles = css`
  color: ${colors.blue.$300};
`

const SolidTypeBadge = styled.span<{ size: BadgeSizeType; color: BadgeColorType }>`
  ${badgeCommonStyles}

  ${({ size }) => size === 'S' && smallSizeBadgeStyles}
  ${({ size }) => size === 'L' && largeSizeBadgeStyles}
    
  ${({ color }) =>
    (color === 'black' &&
      css`
        background-color: #000;
      `) ||
    (color === 'gray' &&
      css`
        background-color: ${colors.gray.$600};
      `) ||
    (color === 'blue' &&
      css`
        background-color: ${colors.blue.$300};
      `) ||
    (color === 'green100' &&
      css`
        background-color: ${colors.green.$100};
      `)}
`

const TextTypeBadge = styled.span<{ size: BadgeSizeType; color: BadgeColorType }>`
  ${badgeCommonStyles}

  ${({ size }) =>
    (size === 'S' && smallSizeBadgeStyles) ||
    (size === 'L' &&
      css`
        ${largeSizeBadgeStyles}
        padding: 2px 4px;
        height: 25px;
      `)}
   
        
    ${({ color }) =>
    (color === 'gray' &&
      css`
        color: ${colors.gray.$500};
      `) ||
    (color === 'blue' &&
      css`
        color: ${colors.blue.$300};
      `) ||
    (color === 'newStudentBlue' &&
      css`
        color: ${colors.studentApp.blue.$500};
      `)}
`
